import React from "react";
import { Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useParams } from "react-router-dom";
import TooltipWrapper from "../../../../../enhancers/TooltipWrapper";
import {
  useDownloadDroppedFiles,
  useGetRLSandboxResourcesStatus
} from "../../../hooks";
import { DROPPED_FILES_ACTIONS } from "../consts";
import { createDroppedFilesActionDisabledMessage } from "../utils";

export type DownloadDroppedFilesButtonProps = {
  analysisId: string;
  isMergedReport: boolean;
  isStoredReport: boolean;
  isNetworkReport?: boolean;
};

const DownloadDroppedFilesButton: React.FC<DownloadDroppedFilesButtonProps> = ({
  analysisId,
  isMergedReport,
  isStoredReport,
  isNetworkReport = false
}) => {
  const {
    hash: summaryDetailsHash,
    sha1: cloudDetailsHash,
    sourceId
  } = useParams();
  const hash = summaryDetailsHash || cloudDetailsHash;
  const { downloadDroppedFiles, isLoading } = useDownloadDroppedFiles(
    hash || "",
    analysisId,
    isNetworkReport
  );
  const { data } = useGetRLSandboxResourcesStatus(
    hash || "",
    analysisId,
    isNetworkReport,
    {
      enabled: Boolean(analysisId)
    }
  );

  const disabledMessage = createDroppedFilesActionDisabledMessage(
    isStoredReport,
    data?.has_dropped_files
  );

  const droppedFilesTitle = isMergedReport
    ? DROPPED_FILES_ACTIONS.DOWNLOAD_LATEST_SHORT
    : DROPPED_FILES_ACTIONS.DOWNLOAD_SHORT;

  return (
    <TooltipWrapper
      condition={isStoredReport || (data && !data.has_dropped_files)}
      wrapper={(children: React.ReactNode) => (
        <OverlayTrigger
          overlay={
            <Tooltip id="download-dropped-files-tooltip">
              {disabledMessage}
            </Tooltip>
          }
          placement="top"
        >
          <div>{children}</div>
        </OverlayTrigger>
      )}
    >
      <Button
        data-testid="download-dropped-files-button"
        className="btn--uppercase"
        disabled={isStoredReport || !data?.has_dropped_files || isLoading}
        size="sm"
        onClick={downloadDroppedFiles}
      >
        {droppedFilesTitle}
      </Button>
    </TooltipWrapper>
  );
};

export default DownloadDroppedFilesButton;
